import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { CursosService } from 'src/app/services/cursos.service';
import * as jQuery from 'jquery';
import { PerfilService } from 'src/app/services/perfil.service';
import { EstudiosService } from 'src/app/services/estudios.service';
import { ExperiencialaboralService } from 'src/app/services/experiencialaboral.service';
import { PremiosService } from 'src/app/services/premios.service';
import { environment } from 'src/environments/environment';



import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import { AlertController, NavController } from '@ionic/angular';
import { ActivatedRoute, Event, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { timeStamp } from 'console';

@Component({
  selector: 'app-profesor-estudiante',
  templateUrl: './profesor-estudiante.component.html',
  styleUrls: ['./profesor-estudiante.component.scss'],
})
export class ProfesorEstudianteComponent implements OnInit {
  @Input() public curso: any;
  @Input() public opcion: any;
  @Input() public data_profesores: any;

  
  argumentos;
  public searchControlProf:FormControl;

  textEditor:FormControl;
  searching:boolean;
  displayUserData:any;
  myData:any = [];
  private ID:number;
  private AUTH_KEY:string;
  profesoresList:any = [];
  usersList:any = [];
  userData:any = [];
  edittext = false;
  tinyMCEConfiguration;
  descripcion:string = '';
  temp = "";
  constructor(
    private sanitizer:DomSanitizer,
    private cursosService:CursosService,
    private authService: AuthService,
    private perfilService:PerfilService,
    private estudiosService: EstudiosService,
    private expLAbService:ExperiencialaboralService,
    private premiosService:PremiosService,
    public fb:FormBuilder,
    public alertController: AlertController,
    private router: Router,
    private navCtrl:NavController,
    private activeRoute:ActivatedRoute,
  ) {
    this.argumentos = this.activeRoute.snapshot.paramMap.get('id_curso');
    console.log('PROFESOR....');
    this.searchControlProf = new FormControl();
    this.searching = false;
    this.textEditor = this.fb.control('');

    this.tinyMCEConfiguration ={
      base_url: '/tinymce', 
      suffix: '.min',
      plugins: 'autoresize',
      max_height: 350   
    }


    this.router.events.subscribe( (event: Event) => {
      if (event instanceof NavigationStart) {
          console.log('event: ',event);
      }

      if (event instanceof NavigationEnd) {
          this.allDataUser([this.ID]).then((success) => {
            if(success){
              this.myData = success;
              let descripcion:any = this.transform(success[0].descripcion);
              this.descripcion = descripcion.changingThisBreaksApplicationSecurity;
              console.log('this.myData: ',this.myData);
            }
          });
          this.confirmarBtn();
      }
      if (event instanceof NavigationError) {
          // Hide loading indicator

          // Present error to user
          console.log(event.error);
      }
  });
  }
  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  loadUserData(){
    let promise = new Promise(resolve => {
      this.authService.userData$.subscribe( (res: any) => {
        if(res){
          if(!this.displayUserData){
            this.displayUserData = res;
            this.ID = this.displayUserData?.id;
            this.AUTH_KEY = this.displayUserData?.auth_key;
            resolve(true);
          }
        }
      });
    });
    promise.then((success) => {
      /********promise********** */
      if(success){
        let usersList = JSON.stringify(this.data_profesores) ;
        console.log('this.data_profesores: ',this.data_profesores);
        this.allDataUser([this.ID]).then((success) => {
          if(success){
            this.myData = success;
            let descripcion:any = this.transform(success[0].descripcion);
            this.descripcion = descripcion.changingThisBreaksApplicationSecurity;
            console.log('this.myData: ',this.myData);
          }
        });
        if(JSON.parse(usersList).length > 0){
          this.usersList = JSON.parse(usersList);
          
          let ids:any = [];
          this.data_profesores.forEach(element => {
            ids.push(element.id);
          });
          this.allDataUser(ids).then((success) => {
            if(success){
              this.userData = success;
            }
          });
          this.profesores();
        }
        this.profesores();
        this.searchControlProf.valueChanges
            .pipe(debounceTime(700))
            .subscribe(search => {
            this.searching = true;
            let searchC:any = this.searchControlProf;
            
            this.setFilteredItems(search);
        });
      }
      /********fin promise********** */
    });
  }
  getUserImage(imagenes,imgDefault = false){
    let imagen:string = null;
    if(imgDefault){
      imagen = 'assets/imagenes/profesor.png';
    }
    if(imagenes.length > 0)
    imagenes.forEach(element => {
      if(element.tipo == 2){
        imagen = environment.host+'/'+ element.url+element.name;
      }
    });
    return imagen
  }
  getUserBanner(imagenes){
    let imagen:string = null;
    
    if(imagenes.length > 0)
    imagenes.forEach(element => {
      if(element.tipo == 1){
        imagen = element.url+element.name;
      }
    });
    return imagen
  }
  allDataUser(ids=null):Promise<any>{
    return new Promise(resolve => {
      if(ids == null || ids.length == 0){
        resolve(false);
      }else{
        this.perfilService.getPerfilByIds(this.ID,this.AUTH_KEY,ids).subscribe( (res:any) => {
          let respuesta:any;
          respuesta = JSON.parse(res) ;
          if(respuesta.auth_key){
            
            resolve(respuesta.data);
          }else{
            //logout
            resolve(false);
          }
        });
      }
    });
  }
  ngOnInit() {
    this.loadUserData();
  }
  setFilteredItems(search){
    this.profesores(search)
  }
  profesores(params=""){
    this.cursosService.getProfesores(this.ID,this.AUTH_KEY,params, this.curso.id).subscribe(response => {
      let list:any = response;
      list.users.forEach( (element,i) => {
        if(element.id == this.ID){
          list.users.splice(i,1);
        }
      });
      this.profesoresList = list.users;
    });
  }

  checkProfesor(el){
    let checkbox = (jQuery(el.target));
    let id = jQuery(checkbox).data('id');

    let user = this.profesoresList.find(element => element.id == id);
    let img = jQuery(checkbox).closest('.card-box').find('.img-chk');
    if(jQuery(checkbox).is(':checked')){
      jQuery(img).addClass('active');
      this.usersList.push(user);
    }else{
      this.usersList.forEach( (element, i) => {
        if(element.id == id){
          this.usersList.splice(i,1);
        }
      });
      jQuery(img).removeClass('active');
    }
    
  }
  isChekked(id){
    let ischekked = false;
    let user = null;
    if(this.usersList.length > 0){
      user = this.usersList.find(element => element.id == id);
    }
    if(user != undefined){
      ischekked = true;
    }
    
    return ischekked;
  }
  confirmarBtn(){
    this.data_profesores.splice(0,this.data_profesores.length);
    if(this.userData.length > 0)
    this.userData.splice(0,this.userData.length);
    this.usersList.forEach( (element,i, array) => {
      this.data_profesores.push(element);
      if(i == (array.length - 1)){
        let ids:any = [];
        this.data_profesores.forEach(element => {
          ids.push(element.id);
        });
        
        this.allDataUser(ids).then((success) => {
          if(success){
            this.userData = success;
            let idsP:any = [];
            this.userData.forEach(profesores => {
              idsP.push(profesores.id_user);
            });

            let params = {
              'users_id':idsP,
              'id_curso':this.argumentos
            };
            this.cursosService.addEmailListProfesorCurso(this.ID,this.AUTH_KEY,params).subscribe(response => {
              let list:any = response;
              console.log('response: ',response);
            });

            console.log('this.userData: ',this.userData);
          }
        });
      }
    });
    
  }

  trabajoActual(tactual){
    let tarbajo_act = 'ninguno';
    tactual.forEach(element => {
      if(element.actual == 1){
        tarbajo_act = element.empresa
      }
    });
    return tarbajo_act;
  }
  
  editText(){
    this.edittext = !this.edittext;
  }



  
 
  async actionSaveDescription(header,message){
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: 'Aceptar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (res) => {
          }
        }
      ]
    });

    await alert.present();
  }
  
  
  
  
  
  

}
